import { render, staticRenderFns } from "./PersonalDataPage.vue?vue&type=template&id=246998a0&scoped=true"
import script from "./PersonalDataPage.vue?vue&type=script&lang=js"
export * from "./PersonalDataPage.vue?vue&type=script&lang=js"
import style0 from "./PersonalDataPage.vue?vue&type=style&index=0&id=246998a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246998a0",
  null
  
)

export default component.exports